import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import { DeliveryMethodModel, PermissionDeliveryModel } from '../model/DeliveryMethodModel';
import { BranchModel } from '../model/BranchModel.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetCartDelivery
 * @method apiPostCartDelivery
 * @method apiGetPermissionDelivery
 * @method apiGetBranch
 */
export default {
    /**
     * Get Delivery.
     */
    apiGetCartDelivery: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/delivery';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            var objDeliveryMethod = new DeliveryMethodModel()
            objDeliveryMethod.setValueFormApi(res.data);
            
            return objDeliveryMethod;
        }));
    },
    /**
     * Post Delivery.
     */
     apiPostCartDelivery: function (param) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/delivery';
        return BzbsApi.connectBzbsPost(url, token, param).pipe(map((res) => {
            var objDeliveryMethod = new DeliveryMethodModel()
            objDeliveryMethod.setValueFormApi(res.data);
            
            return objDeliveryMethod;
        }));
    },
    /**
     * Get Permission Delivery.
     */
    apiGetPermissionDelivery: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/main/delivery';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            var objDeliveryMethod = {};
            objDeliveryMethod = new PermissionDeliveryModel(res.data);
            return objDeliveryMethod;
        }));
    },

    /**
     * Get Branch
     */
    apiGetBranch: function (param) {
        let token = Account.getToken();
        let url = ConfigManager.getApiUrl() + '/place';
        return BzbsApi.connectBzbsGet(url, token, param).pipe(map((res) => {
            var arrBranch = [];
            for (var i of res.data) {
                var objBranch = new BranchModel(i);
                arrBranch.push(objBranch);
            }
            return arrBranch;

        }));
    },
}
